import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcOffersOl = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.0507 3.50281C12.6835 3.13556 12.1721 2.95041 11.6548 2.99743L5.17301 3.58669C4.3317 3.66317 3.66512 4.32975 3.58864 5.17106L2.99938 11.6529C2.95236 12.1701 3.13751 12.6815 3.50476 13.0487L10.9517 20.4957C11.6352 21.1791 12.7432 21.1791 13.4266 20.4957L20.4977 13.4247C21.1811 12.7412 21.1811 11.6332 20.4977 10.9498L13.0507 3.50281ZM11.7906 4.49127C11.8645 4.48455 11.9376 4.511 11.99 4.56347L19.437 12.0104C19.5347 12.1081 19.5347 12.2664 19.437 12.364L12.366 19.4351C12.2683 19.5327 12.11 19.5327 12.0124 19.4351L4.56542 11.9881C4.51296 11.9356 4.48651 11.8626 4.49322 11.7887L5.08248 5.30686C5.0934 5.18668 5.18863 5.09145 5.30882 5.08053L11.7906 4.49127ZM8 7C7.44772 7 7 7.44772 7 8V8.00267C7 8.55495 7.44772 9.00267 8 9.00267H8.00267C8.55495 9.00267 9.00267 8.55495 9.00267 8.00267V8C9.00267 7.44772 8.55495 7 8.00267 7H8Z",
		fill: "inherit"
	})
});
export default SvgIcOffersOl;
